window.addEventListener('DOMContentLoaded', () => {
  const dropdown = document.querySelectorAll('[data-dropdown]');

  if (dropdown) {
    Array.from(dropdown).forEach(target => {
      target.addEventListener('change', () => {
        const placeholder = document.querySelector(
          `[data-dropdown-placeholder=${target.getAttribute('data-dropdown')}]`
        );
        if (!placeholder) return;
        placeholder.innerHTML = target.getAttribute('data-dropdown-label');
      });
    });
  }
});
